import React from 'react';
import ZoningBackstageModelsContentManageTs from 'src/routes/ZoningBackstage/models/contentManage.ts';
import ZoningBackstageModelsEventManageTs from 'src/routes/ZoningBackstage/models/eventManage.ts';
import ZoningBackstageModelsZoneIdentityManageTsx from 'src/routes/ZoningBackstage/models/zoneIdentityManage.tsx';
import ZoningBackstageModelsUnitManageTsx from 'src/routes/ZoningBackstage/models/unitManage.tsx';
import ZoningBackstageModelsDistrictManageTsx from 'src/routes/ZoningBackstage/models/districtManage.tsx';
import WorkSummaryModelsIndexTsx from 'src/routes/WorkSummary/models/index.tsx';
import WorkPlanModelsIndexTsx from 'src/routes/WorkPlan/models/index.tsx';
import WarningMessagesModelsIndexJs from 'src/routes/WarningMessages/models/index.js';
import VirtualOrganizationModelsIndexJs from 'src/routes/VirtualOrganization/models/index.js';
import UnitPersonalCardManageModelsIndexTs from 'src/routes/UnitPersonalCardManage/models/index.ts';
import UnitModelsIndexJs from 'src/routes/Unit/models/index.js';
import TripOrderModelsIndexJs from 'src/routes/TripOrder/models/index.js';
import TotalBudgetModelsProjectSubjectSummaryTs from 'src/routes/TotalBudget/models/projectSubjectSummary.ts';
import TotalBudgetModelsPerformIndicatorTs from 'src/routes/TotalBudget/models/performIndicator.ts';
import TotalBudgetModelsGovBudgetProjectTs from 'src/routes/TotalBudget/models/govBudgetProject.ts';
import TotalBudgetModelsProjectManageTs from 'src/routes/TotalBudget/models/projectManage.ts';
import TotalBudgetModelsCostItemTs from 'src/routes/TotalBudget/models/costItem.ts';
import TotalBudgetModelsRevisedFormQueryTs from 'src/routes/TotalBudget/models/revisedFormQuery.ts';
import TotalBudgetModelsFormBudgetQueryTs from 'src/routes/TotalBudget/models/formBudgetQuery.ts';
import TotalBudgetModelsBudgetAddReductionTs from 'src/routes/TotalBudget/models/budgetAddReduction.ts';
import TotalBudgetModelsDetailedBudgetTs from 'src/routes/TotalBudget/models/detailedBudget.ts';
import TotalBudgetModelsPurchaseSituationTs from 'src/routes/TotalBudget/models/purchaseSituation.ts';
import TotalBudgetModelsBudgetAdjustTs from 'src/routes/TotalBudget/models/budgetAdjust.ts';
import TotalBudgetModelsPerformTableTs from 'src/routes/TotalBudget/models/performTable.ts';
import TotalBudgetModelsBudgetPlanningTs from 'src/routes/TotalBudget/models/budgetPlanning.ts';
import TotalBudgetModelsBudgetTemplateTs from 'src/routes/TotalBudget/models/budgetTemplate.ts';
import TotalBudgetModelsBudgetSubjectTs from 'src/routes/TotalBudget/models/budgetSubject.ts';
import TotalBudgetModelsBudgetProjectTs from 'src/routes/TotalBudget/models/budgetProject.ts';
import TotalBudgetModelsUnitManageTs from 'src/routes/TotalBudget/models/unitManage.ts';
import TotalBudgetModelsProjectLibraryTs from 'src/routes/TotalBudget/models/projectLibrary.ts';
import TotalBudgetModelsFundBudgetTs from 'src/routes/TotalBudget/models/fundBudget.ts';
import ThirdLicenseModelsIndexTs from 'src/routes/ThirdLicense/models/index.ts';
import TenderConfirmationExamineModelsIndexJs from 'src/routes/TenderConfirmationExamine/models/index.js';
import TenantManageModelsDetailTs from 'src/routes/TenantManage/models/detail.ts';
import TenantManageModelsListTs from 'src/routes/TenantManage/models/list.ts';
import SupplierInfoModelsIndexTs from 'src/routes/SupplierInfo/models/index.ts';
import SupplierModelsIndexTs from 'src/routes/Supplier/models/index.ts';
import SmallEntrustModelsIndexTs from 'src/routes/SmallEntrust/models/index.ts';
import SmallCollectionModelsCollectionDetailsTs from 'src/routes/SmallCollection/models/collectionDetails.ts';
import SensitiveWordModelsIndexTs from 'src/routes/SensitiveWord/models/index.ts';
import SalaryModelsSalaryProjectManageTs from 'src/routes/Salary/models/salaryProjectManage.ts';
import SalaryModelsTemplateManageTs from 'src/routes/Salary/models/templateManage.ts';
import SalaryModelsPayeeManageTs from 'src/routes/Salary/models/payeeManage.ts';
import SalaryModelsIndexTs from 'src/routes/Salary/models/index.ts';
import PurchaseWorkbenchModelsIndexJs from 'src/routes/PurchaseWorkbench/models/index.js';
import PurchaseDeclareModelsIndexJs from 'src/routes/PurchaseDeclare/models/index.js';
import PurchaseConfigModelsIndexTs from 'src/routes/PurchaseConfig/models/index.ts';
import ProjectManageModelsIndexTs from 'src/routes/ProjectManage/models/index.ts';
import ProcurementAndReimbursementModelsIndexTs from 'src/routes/ProcurementAndReimbursement/models/index.ts';
import PrivilegeAllocationModelsIndexJs from 'src/routes/PrivilegeAllocation/models/index.js';
import PrivilegeModelsIndexJs from 'src/routes/Privilege/models/index.js';
import PersonnelManagementModelsIndexTsx from 'src/routes/PersonnelManagement/models/index.tsx';
import PendingMessagesModelsApplyJs from 'src/routes/PendingMessages/models/apply.js';
import PendingMessagesModelsIndexJs from 'src/routes/PendingMessages/models/index.js';
import OvertimeManageModelsIndexJs from 'src/routes/OvertimeManage/models/index.js';
import OtherFundsOfTheUnitModelsQuotaTs from 'src/routes/OtherFundsOfTheUnit/models/quota.ts';
import OtherFundsOfTheUnitModelsSubjectConfigTs from 'src/routes/OtherFundsOfTheUnit/models/subjectConfig.ts';
import OrgEconomicSubjectModelsIndexJs from 'src/routes/OrgEconomicSubject/models/index.js';
import OfficalCardManageModelsIndexTs from 'src/routes/OfficalCardManage/models/index.ts';
import NoticeMessagesModelsIndexJs from 'src/routes/NoticeMessages/models/index.js';
import MeetingSignModelsIndexTs from 'src/routes/MeetingSign/models/index.ts';
import MedicalIncomeAnalysisModelsIndexTs from 'src/routes/MedicalIncomeAnalysis/models/index.ts';
import ManagementModelsTenantJs from 'src/routes/Management/models/tenant.js';
import ManagementModelsInstitutionJs from 'src/routes/Management/models/institution.js';
import LogManageModelsIndexTs from 'src/routes/LogManage/models/index.ts';
import InvoiceManageModelsIndexTs from 'src/routes/InvoiceManage/models/index.ts';
import InvoiceListModelsIndexJs from 'src/routes/InvoiceList/models/index.js';
import InvoiceModelsIndexJs from 'src/routes/Invoice/models/index.js';
import IntercourseFundsModelsIndexTsx from 'src/routes/IntercourseFunds/models/index.tsx';
import IncomeManageModelsIndexTsx from 'src/routes/IncomeManage/models/index.tsx';
import HospitalRevenueModelsIndexTs from 'src/routes/HospitalRevenue/models/index.ts';
import HolidaySettingModelsIndexTs from 'src/routes/HolidaySetting/models/index.ts';
import GovernmentProjectModelsIndexTsx from 'src/routes/GovernmentProject/models/index.tsx';
import FinanceInvoiceListModelsIndexJs from 'src/routes/FinanceInvoiceList/models/index.js';
import FileRefluxModelsIndexTs from 'src/routes/FileReflux/models/index.ts';
import FeeItemManageModelsStandardTs from 'src/routes/FeeItemManage/models/standard.ts';
import FeeItemManageModelsBasicDataTs from 'src/routes/FeeItemManage/models/basicData.ts';
import FeeItemManageModelsItemListTs from 'src/routes/FeeItemManage/models/itemList.ts';
import FeeControlModelsIndexTs from 'src/routes/FeeControl/models/index.ts';
import ExternalUserModelsIndexTsx from 'src/routes/ExternalUser/models/index.tsx';
import ExternalPersonModelsIndexJs from 'src/routes/ExternalPerson/models/index.js';
import ExpertLibraryModelsIndexTs from 'src/routes/ExpertLibrary/models/index.ts';
import ExecutionUnitModelsIndexJs from 'src/routes/ExecutionUnit/models/index.js';
import ExceptionRecordModelsDeleteOrgTs from 'src/routes/ExceptionRecord/models/deleteOrg.ts';
import ExceptionRecordModelsExceptionTsx from 'src/routes/ExceptionRecord/models/exception.tsx';
import ExceptionRecordModelsIndexTs from 'src/routes/ExceptionRecord/models/index.ts';
import EventManageModelsIndexTs from 'src/routes/EventManage/models/index.ts';
import EmployeeModelsIndexJs from 'src/routes/Employee/models/index.js';
import EconomicSubjectModelsIndexJs from 'src/routes/EconomicSubject/models/index.js';
import DriverManageModelsIndexTsx from 'src/routes/DriverManage/models/index.tsx';
import DinnerFeeModelsIndexTsx from 'src/routes/DinnerFee/models/index.tsx';
import DingTalkExecuteModelsIndexTs from 'src/routes/DingTalkExecute/models/index.ts';
import DepartmentModelsIndexJs from 'src/routes/Department/models/index.js';
import ControlPlatformModelsIndexJs from 'src/routes/ControlPlatform/models/index.js';
import ContractModelsIndexTs from 'src/routes/Contract/models/index.ts';
import ConsumptionRecordsMangeModelsIndexTs from 'src/routes/ConsumptionRecordsMange/models/index.ts';
import ClaimListModelsIndexJs from 'src/routes/ClaimList/models/index.js';
import ClaimModelsPurchaseJs from 'src/routes/Claim/models/purchase.js';
import ClaimModelsBatchDistributeExpenseJs from 'src/routes/Claim/models/batchDistributeExpense.js';
import ClaimModelsContractJs from 'src/routes/Claim/models/contract.js';
import ClaimModelsOrderTs from 'src/routes/Claim/models/order.ts';
import ClaimModelsApplyJs from 'src/routes/Claim/models/apply.js';
import ClaimModelsIndexJs from 'src/routes/Claim/models/index.js';
import CashierModelsIndexJs from 'src/routes/Cashier/models/index.js';
import CarUseApplyFormListModelsIndexTs from 'src/routes/CarUseApplyFormList/models/index.ts';
import BusinessTripModelsIndexTsx from 'src/routes/BusinessTrip/models/index.tsx';
import BusinessCardModelsIndexJs from 'src/routes/BusinessCard/models/index.js';
import BudgetQuotaModelsIndexJs from 'src/routes/BudgetQuota/models/index.js';
import BudgetPerformModelsIndexTs from 'src/routes/BudgetPerform/models/index.ts';
import BudgetIndicatorsModelsIndexJs from 'src/routes/BudgetIndicators/models/index.js';
import BatchExecuteModelsIndexTsx from 'src/routes/BatchExecute/models/index.tsx';
import BatchDistributeModelsIndexTsx from 'src/routes/BatchDistribute/models/index.tsx';
import BasicInfoMaintainModelsIndexTsx from 'src/routes/BasicInfoMaintain/models/index.tsx';
import BankReceiptTransforModelsIndexJs from 'src/routes/BankReceiptTransfor/models/index.js';
import BankReceiptModelsIndexJs from 'src/routes/BankReceipt/models/index.js';
import BankCardModelsIndexJs from 'src/routes/BankCard/models/index.js';
import AuthorityModelsIndexJs from 'src/routes/Authority/models/index.js';
import AttendanceConfigModelsIndexTs from 'src/routes/AttendanceConfig/models/index.ts';
import AssetAuditModelsIndexTsx from 'src/routes/AssetAudit/models/index.tsx';
import AssetModelsIndexTsx from 'src/routes/Asset/models/index.tsx';
import AppraiseManagementModelsIndexJs from 'src/routes/AppraiseManagement/models/index.js';
import ApplyModelsIndexJs from 'src/routes/Apply/models/index.js';
import AllListModelsIndexJs from 'src/routes/AllList/models/index.js';
import AcrossUnitModelsIndexJs from 'src/routes/AcrossUnit/models/index.js';
import AccountingVoucherModelsIndexJs from 'src/routes/AccountingVoucher/models/index.js';
import AccountingToolsModelsIndexJs from 'src/routes/AccountingTools/models/index.js';
import AccountingSubjectModelsIndexTs from 'src/routes/AccountingSubject/models/index.ts';
import AccountBalancesCheckingModelsIndexTsx from 'src/routes/AccountBalancesChecking/models/index.tsx';
import AbnormalDocumentModelsIndexTsx from 'src/routes/AbnormalDocument/models/index.tsx';
import AbnormalDataUserModelsIndexTs from 'src/routes/AbnormalDataUser/models/index.ts';

export default { 
  "/claim/abnormal-users": {
    component: React.lazy(() => import('src/routes/AbnormalDataUser/views/index')),
    models: [
      AbnormalDataUserModelsIndexTs
    ],
  },
  "/claim/abnormal-document/list": {
    component: React.lazy(() => import('src/routes/AbnormalDocument/views/index')),
    models: [
      AbnormalDocumentModelsIndexTsx
    ],
  },
  "/claim/account-balances-checking/index": {
    component: React.lazy(() => import('src/routes/AccountBalancesChecking/views/index')),
    models: [
      AccountBalancesCheckingModelsIndexTsx
    ],
  },
  "/claim/accounting-subject/index": {
    component: React.lazy(() => import('src/routes/AccountingSubject/views/index')),
    models: [
      AccountingSubjectModelsIndexTs
    ],
  },
  "/claim/accounting-tools/unfinished-transactions": {
    component: React.lazy(() => import('src/routes/AccountingTools/views/unfinishedTransactions')),
    models: [
      AccountingToolsModelsIndexJs
    ],
  },
  "/claim/accounting/voucher": {
    component: React.lazy(() => import('src/routes/AccountingVoucher/views/index')),
    models: [
      AccountingVoucherModelsIndexJs
    ],
  },
  "/claim/across-unit/manage": {
    component: React.lazy(() => import('src/routes/AcrossUnit/views/index')),
    models: [
      AcrossUnitModelsIndexJs
    ],
  },
  "/claim/address-manage": {
    component: React.lazy(() => import('src/routes/AddressManage/views/index')),
  },
  "/claim/my-document/list": {
    component: React.lazy(() => import('src/routes/AllList/views/myList')),
    models: [
      AllListModelsIndexJs
    ],
  },
  "/claim/purchase/list": {
    component: React.lazy(() => import('src/routes/AllList/views/purchaseList')),
    models: [
      AllListModelsIndexJs
    ],
  },
  "/claim/all-my-document/list": {
    component: React.lazy(() => import('src/routes/AllList/views/allMyList')),
    models: [
      AllListModelsIndexJs
    ],
  },
  "/claim/approval-document/list": {
    component: React.lazy(() => import('src/routes/AllList/views/approvalList')),
    models: [
      AllListModelsIndexJs
    ],
  },
  "/claim/finance-document/list": {
    component: React.lazy(() => import('src/routes/AllList/views/financeList')),
    models: [
      AllListModelsIndexJs
    ],
  },
  "/claim/history-document/list": {
    component: React.lazy(() => import('src/routes/AllList/views/historyList')),
    models: [
      AllListModelsIndexJs
    ],
  },
  "/claim/operation-document/list": {
    component: React.lazy(() => import('src/routes/AllList/views/operationList')),
    models: [
      AllListModelsIndexJs
    ],
  },
  "/claim/cashier-document/list": {
    component: React.lazy(() => import('src/routes/AllList/views/cashierList')),
    models: [
      AllListModelsIndexJs
    ],
  },
  "/claim/reimburse-document/list": {
    component: React.lazy(() => import('src/routes/AllList/views/reimburseList')),
    models: [
      AllListModelsIndexJs
    ],
  },
  "/claim/apply-manage/index": {
    component: React.lazy(() => import('src/routes/Apply/views/index')),
    models: [
      ApplyModelsIndexJs
    ],
  },
  "/claim/admin/attendance/adminList": {
    component: React.lazy(() => import('src/routes/AppraiseManagement/views/adminList')),
    models: [
      AppraiseManagementModelsIndexJs
    ],
  },
  "/claim/admin/attendance/adminDetail": {
    component: React.lazy(() => import('src/routes/AppraiseManagement/views/adminDetail')),
    models: [
      AppraiseManagementModelsIndexJs
    ],
  },
  "/claim/assessor/attendance/assessorList": {
    component: React.lazy(() => import('src/routes/AppraiseManagement/views/assessorList')),
    models: [
      AppraiseManagementModelsIndexJs
    ],
  },
  "/claim/assessor/attendance/assessorDetail": {
    component: React.lazy(() => import('src/routes/AppraiseManagement/views/assessorDetail')),
    models: [
      AppraiseManagementModelsIndexJs
    ],
  },
  "/claim/asset": {
    component: React.lazy(() => import('src/routes/Asset/views/index')),
    models: [
      AssetModelsIndexTsx
    ],
  },
  "/claim/asset-audit": {
    component: React.lazy(() => import('src/routes/AssetAudit/views/index')),
    models: [
      AssetAuditModelsIndexTsx
    ],
  },
  "/claim/attendance/config": {
    component: React.lazy(() => import('src/routes/AttendanceConfig/views/index')),
    models: [
      AttendanceConfigModelsIndexTs
    ],
  },
  "/claim/attendance/overtimeConfig": {
    component: React.lazy(() => import('src/routes/AttendanceConfig/views/overtime')),
    models: [
      AttendanceConfigModelsIndexTs
    ],
  },
  "/claim/attendance/personal": {
    component: React.lazy(() => import('src/routes/AttendanceManage/views/personal')),
  },
  "/claim/attendance/department": {
    component: React.lazy(() => import('src/routes/AttendanceManage/views/department')),
  },
  "/claim/attendance/overview": {
    component: React.lazy(() => import('src/routes/AttendanceManage/views/overview')),
  },
  "/claim/attendance/checkList": {
    component: React.lazy(() => import('src/routes/AttendanceManage/views/checkList')),
  },
  "/claim/attendance/ovetimeList/:type?": {
    component: React.lazy(() => import('src/routes/AttendanceManage/views/overtimeList')),
  },
  "/claim/authority/setting/:fromPage?": {
    component: React.lazy(() => import('src/routes/Authority/views/index')),
    models: [
      AuthorityModelsIndexJs
    ],
  },
  "/claim/baida-fee-manage/list": {
    component: React.lazy(() => import('src/routes/BaidaFeeManage/views/index')),
  },
  "/claim/baida-form-manage/list": {
    component: React.lazy(() => import('src/routes/BaidaFormMange/views/list')),
  },
  "/claim/baida-form-manage/audit": {
    component: React.lazy(() => import('src/routes/BaidaFormMange/views/audit')),
  },
  "/claim/bank-card/manage": {
    component: React.lazy(() => import('src/routes/BankCard/views/index')),
    models: [
      BankCardModelsIndexJs
    ],
  },
  "/claim/bank/receipt/list": {
    component: React.lazy(() => import('src/routes/BankReceipt/views/index')),
    models: [
      BankReceiptModelsIndexJs
    ],
  },
  "undefined": {
    component: React.lazy(() => import('src/routes/BankReceiptTransfor/views/index')),
    models: [
      BankReceiptTransforModelsIndexJs
    ],
  },
  "/claim/basic-info/maintain": {
    component: React.lazy(() => import('src/routes/BasicInfoMaintain/views/index')),
    models: [
      BasicInfoMaintainModelsIndexTsx
    ],
  },
  "/claim/batch-distribute/:type?": {
    component: React.lazy(() => import('src/routes/BatchDistribute/views/index')),
    models: [
      BatchDistributeModelsIndexTsx
    ],
  },
  "/claim/batch-distribute-approval": {
    component: React.lazy(() => import('src/routes/BatchDistributeApproval/views/index')),
  },
  "/claim/batch-execute": {
    component: React.lazy(() => import('src/routes/BatchExecute/views/index')),
    models: [
      BatchExecuteModelsIndexTsx
    ],
  },
  "/claim/bridge/:pageId": {
    component: React.lazy(() => import('src/routes/Bridge/views/iframe')),
  },
  "/claim/middleJumpPage": {
    component: React.lazy(() => import('src/routes/Bridge/views/middleJumpPage')),
  },
  "/claim/budget/split": {
    component: React.lazy(() => import('src/routes/Budget/views/split')),
  },
  "/claim/budget/adjust": {
    component: React.lazy(() => import('src/routes/Budget/views/adjust')),
  },
  "/claim/budget/search": {
    component: React.lazy(() => import('src/routes/Budget/views/search')),
  },
  "/claim/budget/budget-index-decomposition": {
    component: React.lazy(() => import('src/routes/Budget/views/budgetIndexDecomposition/index')),
  },
  "/claim/budget/budget-quota-decomposition": {
    component: React.lazy(() => import('src/routes/Budget/views/budgetQuotaDecomposition/index')),
  },
  "/claim/budget/config-manage": {
    component: React.lazy(() => import('src/routes/BudgetConfigManage/views/index')),
  },
  "/claim/budget/indicators": {
    component: React.lazy(() => import('src/routes/BudgetIndicators/views/index')),
    models: [
      BudgetIndicatorsModelsIndexJs
    ],
  },
  "/claim/budget/query-list": {
    component: React.lazy(() => import('src/routes/BudgetIndicators/views/queryList')),
    models: [
      BudgetIndicatorsModelsIndexJs
    ],
  },
  "/claim/budget/perform/list": {
    component: React.lazy(() => import('src/routes/BudgetPerform/views/index')),
    models: [
      BudgetPerformModelsIndexTs
    ],
  },
  "/claim/budget/perform/manage/list": {
    component: React.lazy(() => import('src/routes/BudgetPerform/views/index')),
    models: [
      BudgetPerformModelsIndexTs
    ],
  },
  "/claim/budget/quota": {
    component: React.lazy(() => import('src/routes/BudgetQuota/views/index')),
    models: [
      BudgetQuotaModelsIndexJs
    ],
  },
  "/claim/budgetReport/budget-template-management/list": {
    component: React.lazy(() => import('src/routes/BudgetReport/views/budgetTemplateManagement/index')),
  },
  "/claim/budgetReport/budget-template-setting/:uk": {
    component: React.lazy(() => import('src/routes/BudgetReport/views/budgetTemplateSetting/index')),
  },
  "/claim/budgetReport/budget-according": {
    component: React.lazy(() => import('src/routes/BudgetReport/views/budgetAccording/index')),
  },
  "/claim/budgetReport/budget-report": {
    component: React.lazy(() => import('src/routes/BudgetReport/views/budgetReport/index')),
  },
  "/claim/budgetReport/budget-issuance": {
    component: React.lazy(() => import('src/routes/BudgetReport/views/budgetIssuance/index')),
  },
  "/claim/official-card/manage": {
    component: React.lazy(() => import('src/routes/BusinessCard/views/index')),
    models: [
      BusinessCardModelsIndexJs
    ],
  },
  "/claim/business-trip/index": {
    component: React.lazy(() => import('src/routes/BusinessTrip/views/index')),
    models: [
      BusinessTripModelsIndexTsx
    ],
  },
  "/claim/car-manage/list": {
    component: React.lazy(() => import('src/routes/CarManage/views/index')),
  },
  "/claim/car-use-apply-form/list": {
    component: React.lazy(() => import('src/routes/CarUseApplyFormList/views/index')),
    models: [
      CarUseApplyFormListModelsIndexTs
    ],
  },
  "/claim/cashier/list": {
    component: React.lazy(() => import('src/routes/Cashier/views/index')),
    models: [
      CashierModelsIndexJs
    ],
  },
  "/claim/cashier/detail/:id": {
    component: React.lazy(() => import('src/routes/Cashier/views/detail')),
    models: [
      CashierModelsIndexJs
    ],
  },
  "/claim/cashier/ticket-detail/:id": {
    component: React.lazy(() => import('src/routes/Cashier/views/ticketDetail')),
    models: [
      CashierModelsIndexJs
    ],
  },
  "/claim/cashier/replenish-invoice": {
    component: React.lazy(() => import('src/routes/Cashier/views/replenishInvoice')),
    models: [
      CashierModelsIndexJs
    ],
  },
  "/claim/claim-manage/index": {
    component: React.lazy(() => import('src/routes/Claim/views/index')),
    models: [
      ClaimModelsIndexJs,
      ClaimModelsApplyJs,
      ClaimModelsOrderTs,
      ClaimModelsContractJs,
      ClaimModelsBatchDistributeExpenseJs,
      ClaimModelsPurchaseJs
    ],
  },
  "/claim/claim-list/list": {
    component: React.lazy(() => import('src/routes/ClaimList/views/index')),
    models: [
      ClaimListModelsIndexJs
    ],
  },
  "/claim/claim-list/detail/:id": {
    component: React.lazy(() => import('src/routes/ClaimList/views/detail')),
    models: [
      ClaimListModelsIndexJs
    ],
  },
  "/claim/company-account-management/index": {
    component: React.lazy(() => import('src/routes/CompanyAccountManagement/views/index')),
  },
  "/claim/config-manage/list": {
    component: React.lazy(() => import('src/routes/ConfigManage/views/index')),
  },
  "/claim/config/purchase": {
    component: React.lazy(() => import('src/routes/ConfigManage/views/purchase')),
  },
  "/claim/consumption-records/index": {
    component: React.lazy(() => import('src/routes/ConsumptionRecordsMange/views/index')),
    models: [
      ConsumptionRecordsMangeModelsIndexTs
    ],
  },
  "/claim/contract/list": {
    component: React.lazy(() => import('src/routes/Contract/views/index')),
    models: [
      ContractModelsIndexTs
    ],
  },
  "/claim/contract/manage": {
    component: React.lazy(() => import('src/routes/Contract/views/index')),
    models: [
      ContractModelsIndexTs
    ],
  },
  "/claim/control-platform": {
    component: React.lazy(() => import('src/routes/ControlPlatform/views/index')),
    models: [
      ControlPlatformModelsIndexJs
    ],
  },
  "/claim/content/development": {
    component: React.lazy(() => import('src/routes/ControlPlatform/views/development')),
    models: [
      ControlPlatformModelsIndexJs
    ],
  },
  "/claim/cost-manage": {
    component: React.lazy(() => import('src/routes/CostManage/views/index')),
  },
  "/claim/dashboard": {
    component: React.lazy(() => import('src/routes/Dashboard/views/index')),
  },
  "/claim/question": {
    component: React.lazy(() => import('src/routes/Dashboard/views/question')),
  },
  "/claim/databoard": {
    component: React.lazy(() => import('src/routes/DataBoard/views/index')),
  },
  "/claim/declaration/list": {
    component: React.lazy(() => import('src/routes/DeclarationList/views/index')),
  },
  "/claim/depart-schedule/:type?": {
    component: React.lazy(() => import('src/routes/DepartSchedule/views/index')),
  },
  "/claim/department": {
    component: React.lazy(() => import('src/routes/Department/views/index')),
    models: [
      DepartmentModelsIndexJs
    ],
  },
  "/claim/dingTalk/execute": {
    component: React.lazy(() => import('src/routes/DingTalkExecute/views/index')),
    models: [
      DingTalkExecuteModelsIndexTs
    ],
  },
  "/claim/dinner-fee/list": {
    component: React.lazy(() => import('src/routes/DinnerFee/views/index.tsx')),
    models: [
      DinnerFeeModelsIndexTsx
    ],
  },
  "/claim/driver/manage": {
    component: React.lazy(() => import('src/routes/DriverManage/views/index')),
    models: [
      DriverManageModelsIndexTsx
    ],
  },
  "/claim/economic/subject": {
    component: React.lazy(() => import('src/routes/EconomicSubject/views/index')),
    models: [
      EconomicSubjectModelsIndexJs
    ],
  },
  "/claim/employee": {
    component: React.lazy(() => import('src/routes/Employee/views/index')),
    models: [
      EmployeeModelsIndexJs
    ],
  },
  "/claim/delete-employee/index": {
    component: React.lazy(() => import('src/routes/Employee/views/deleteEmployee')),
    models: [
      EmployeeModelsIndexJs
    ],
  },
  "/claim/operation/event-manage/list": {
    component: React.lazy(() => import('src/routes/EventManage/views/index')),
    models: [
      EventManageModelsIndexTs
    ],
  },
  "/claim/exception/403": {
    component: React.lazy(() => import('src/routes/Exception/views/403')),
  },
  "/claim/exception/404": {
    component: React.lazy(() => import('src/routes/Exception/views/404')),
  },
  "/claim/exception-record": {
    component: React.lazy(() => import('src/routes/ExceptionRecord/views/list')),
    models: [
      ExceptionRecordModelsIndexTs
    ],
  },
  "/claim/exception-records/exception-detail/:id": {
    component: React.lazy(() => import('src/routes/ExceptionRecord/views/ExceptionDetail')),
    models: [
      ExceptionRecordModelsIndexTs,
      ExceptionRecordModelsExceptionTsx
    ],
  },
  "/claim/delete-org/list": {
    component: React.lazy(() => import('src/routes/ExceptionRecord/views/DeleteOrgList')),
    models: [
      ExceptionRecordModelsDeleteOrgTs
    ],
  },
  "/claim/execution/operate/list": {
    component: React.lazy(() => import('src/routes/ExecutionOperate/views/list')),
  },
  "/claim/execution/org/list": {
    component: React.lazy(() => import('src/routes/ExecutionOrg/views/list')),
  },
  "/claim/execution/org-relation/list": {
    component: React.lazy(() => import('src/routes/ExecutionOrgRelation/views/index')),
  },
  "/claim/execution/unit/list": {
    component: React.lazy(() => import('src/routes/ExecutionUnit/views/list')),
    models: [
      ExecutionUnitModelsIndexJs
    ],
  },
  "/claim/execution/unit/detail/:id?/:code?/:name?/:tagType?": {
    component: React.lazy(() => import('src/routes/ExecutionUnit/views/detail')),
    models: [
      ExecutionUnitModelsIndexJs
    ],
  },
  "/claim/execution/unit/documentEdit/:formDefineCode=:code?/:orgId=:id?": {
    component: React.lazy(() => import('src/routes/ExecutionUnit/views/documentEdit')),
    models: [
      ExecutionUnitModelsIndexJs
    ],
  },
  "/claim/expert/library": {
    component: React.lazy(() => import('src/routes/ExpertLibrary/views/index')),
    models: [
      ExpertLibraryModelsIndexTs
    ],
  },
  "/claim/external/person": {
    component: React.lazy(() => import('src/routes/ExternalPerson/views/index')),
    models: [
      ExternalPersonModelsIndexJs
    ],
  },
  "/claim/external/user": {
    component: React.lazy(() => import('src/routes/ExternalUser/views/index')),
    models: [
      ExternalUserModelsIndexTsx
    ],
  },
  "/claim/fee/standard": {
    component: React.lazy(() => import('src/routes/FeeControl/views/Standard/index')),
    models: [
      FeeControlModelsIndexTs
    ],
  },
  "/claim/fee/rule-list": {
    component: React.lazy(() => import('src/routes/FeeControl/views/FeeItem/index')),
    models: [
      FeeControlModelsIndexTs
    ],
  },
  "/claim/fee/add-rule": {
    component: React.lazy(() => import('src/routes/FeeControl/views/AddFeeItem/index')),
    models: [
      FeeControlModelsIndexTs
    ],
  },
  "/claim/fee/item-list": {
    component: React.lazy(() => import('src/routes/FeeItemManage/views/ItemList/index')),
    models: [
      FeeItemManageModelsItemListTs
    ],
  },
  "/claim/fee/basic-list": {
    component: React.lazy(() => import('src/routes/FeeItemManage/views/BasicData/index')),
    models: [
      FeeItemManageModelsBasicDataTs
    ],
  },
  "/claim/fee/standard-list": {
    component: React.lazy(() => import('src/routes/FeeItemManage/views/Standard/index')),
    models: [
      FeeItemManageModelsStandardTs
    ],
  },
  "/claim/file-reflux": {
    component: React.lazy(() => import('src/routes/FileReflux/views/index')),
    models: [
      FileRefluxModelsIndexTs
    ],
  },
  "/claim/finance-invoice-list/index": {
    component: React.lazy(() => import('src/routes/FinanceInvoiceList/views/index')),
    models: [
      FinanceInvoiceListModelsIndexJs
    ],
  },
  "/claim/finance-invoice-list/history": {
    component: React.lazy(() => import('src/routes/FinanceInvoiceList/views/historyList')),
    models: [
      FinanceInvoiceListModelsIndexJs
    ],
  },
  "/claim/government-project/list": {
    component: React.lazy(() => import('src/routes/GovernmentProject/views/index.tsx')),
    models: [
      GovernmentProjectModelsIndexTsx
    ],
  },
  "/claim/government-project/payment-order-list": {
    component: React.lazy(() => import('src/routes/GovernmentProject/views/paymentOrderList.tsx')),
    models: [
      GovernmentProjectModelsIndexTsx
    ],
  },
  "/claim/holiday/setting": {
    component: React.lazy(() => import('src/routes/HolidaySetting/views/index')),
    models: [
      HolidaySettingModelsIndexTs
    ],
  },
  "/claim/medical/income": {
    component: React.lazy(() => import('src/routes/HospitalRevenue/views/MedicalIncome/index')),
    models: [
      HospitalRevenueModelsIndexTs
    ],
  },
  "/claim/medical/record": {
    component: React.lazy(() => import('src/routes/HospitalRevenue/views/MedicalRecord/index')),
    models: [
      HospitalRevenueModelsIndexTs
    ],
  },
  "/claim/income/list": {
    component: React.lazy(() => import('src/routes/IncomeManage/views/index')),
    models: [
      IncomeManageModelsIndexTsx
    ],
  },
  "/claim/income/category-list": {
    component: React.lazy(() => import('src/routes/IncomeManage/views/incomeCategory')),
    models: [
      IncomeManageModelsIndexTsx
    ],
  },
  "/claim/income/audit-list": {
    component: React.lazy(() => import('src/routes/IncomeManage/views/incomeAudit')),
    models: [
      IncomeManageModelsIndexTsx
    ],
  },
  "/claim/intercourse-funds": {
    component: React.lazy(() => import('src/routes/IntercourseFunds/views/index')),
    models: [
      IntercourseFundsModelsIndexTsx
    ],
  },
  "/claim/invoice/index": {
    component: React.lazy(() => import('src/routes/Invoice/views/index')),
    models: [
      InvoiceModelsIndexJs
    ],
  },
  "/claim/invoice-list/index": {
    component: React.lazy(() => import('src/routes/InvoiceList/views/index')),
    models: [
      InvoiceListModelsIndexJs
    ],
  },
  "/claim/zoning-backstage/invoice-manage": {
    component: React.lazy(() => import('src/routes/InvoiceList/views/index')),
    models: [
      InvoiceListModelsIndexJs
    ],
  },
  "/claim/invoice-manage": {
    component: React.lazy(() => import('src/routes/InvoiceManage/views/index')),
    models: [
      InvoiceManageModelsIndexTs
    ],
  },
  "/claim/authority/itinerary-export": {
    component: React.lazy(() => import('src/routes/ItineraryExport/views/index')),
  },
  "/claim/operation/log-manage": {
    component: React.lazy(() => import('src/routes/LogManage/views/index')),
    models: [
      LogManageModelsIndexTs
    ],
  },
  "/claim/LogTable": {
    component: React.lazy(() => import('src/routes/LogTable/views/index')),
  },
  "/claim/longgang/performanceList": {
    component: React.lazy(() => import('src/routes/LongGang/views/performanceList')),
  },
  "/claim/longgang/superviseList": {
    component: React.lazy(() => import('src/routes/LongGang/views/superviseList')),
  },
  "/claim/longgang/eventReporting": {
    component: React.lazy(() => import('src/routes/LongGang/views/eventReporting/eventReportingList')),
  },
  "/claim/longgang/purchaseEstablishment": {
    component: React.lazy(() => import('src/routes/LongGang/views/purchaseEstablishment/purchaseEstablishmentList')),
  },
  "/claim/management/order/outline": {
    component: React.lazy(() => import('src/routes/Management/views/outline')),
    models: [
      ManagementModelsInstitutionJs,
      ManagementModelsTenantJs
    ],
  },
  "/claim/medical/analysis/income": {
    component: React.lazy(() => import('src/routes/MedicalIncomeAnalysis/views/income')),
    models: [
      MedicalIncomeAnalysisModelsIndexTs
    ],
  },
  "/claim/medical/analysis/medicine": {
    component: React.lazy(() => import('src/routes/MedicalIncomeAnalysis/views/medicine')),
    models: [
      MedicalIncomeAnalysisModelsIndexTs
    ],
  },
  "/claim/medical/analysis/case": {
    component: React.lazy(() => import('src/routes/MedicalIncomeAnalysis/views/case')),
    models: [
      MedicalIncomeAnalysisModelsIndexTs
    ],
  },
  "/claim/medical/analysis/cost": {
    component: React.lazy(() => import('src/routes/MedicalIncomeAnalysis/views/cost')),
    models: [
      MedicalIncomeAnalysisModelsIndexTs
    ],
  },
  "/claim/medical/analysis/annualIncome": {
    component: React.lazy(() => import('src/routes/MedicalIncomeAnalysis/views/annualIncome')),
    models: [
      MedicalIncomeAnalysisModelsIndexTs
    ],
  },
  "/claim/meeting-sign/index": {
    component: React.lazy(() => import('src/routes/MeetingSign/views/index')),
    models: [
      MeetingSignModelsIndexTs
    ],
  },
  "/claim/relation/my-all": {
    component: React.lazy(() => import('src/routes/MyAllForms/views/index')),
  },
  "/claim/note-manage/index": {
    component: React.lazy(() => import('src/routes/Note/views/index')),
  },
  "/claim/notice/messages": {
    component: React.lazy(() => import('src/routes/NoticeMessages/views/index')),
    models: [
      NoticeMessagesModelsIndexJs
    ],
  },
  "/claim/official-card/index": {
    component: React.lazy(() => import('src/routes/OfficalCardManage/views/index')),
    models: [
      OfficalCardManageModelsIndexTs
    ],
  },
  "/claim/order-list": {
    component: React.lazy(() => import('src/routes/Order/views/list')),
  },
  "/claim/orgeconomic/subject": {
    component: React.lazy(() => import('src/routes/OrgEconomicSubject/views/index')),
    models: [
      OrgEconomicSubjectModelsIndexJs
    ],
  },
  "/claim/otherFunds/list": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/OtherFundsOfTheUnitList/index')),
  },
  "/claim/incomeExpenditure/list": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/OtherIncomeExpenditureList/index')),
  },
  "/claim/accountBalanceView/list": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/OtherAccountBalanceViewList/index')),
  },
  "/claim/accountRegistration/list": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/AccountRegistration/index')),
  },
  "/claim/otherFunds/subject": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/subjectConfig/index')),
    models: [
      OtherFundsOfTheUnitModelsSubjectConfigTs
    ],
  },
  "/claim/otherFunds/quota": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/quotaList/index')),
    models: [
      OtherFundsOfTheUnitModelsQuotaTs
    ],
  },
  "/claim/otherFunds/pay": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/payList/index')),
  },
  "/claim/otherFunds/instructions": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/OtherFundsInstructions/index')),
  },
  "/claim/accountBusiness/list": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/AccountBusiness/index')),
  },
  "/claim/accountGather/:type?": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/AccountGather/index')),
  },
  "/claim/formworkList/list": {
    component: React.lazy(() => import('src/routes/OtherFundsOfTheUnit/views/formworkList/index')),
  },
  "/claim/overtime-manage/list": {
    component: React.lazy(() => import('src/routes/OvertimeManage/views/index.tsx')),
    models: [
      OvertimeManageModelsIndexJs
    ],
  },
  "/claim/payment-information/list": {
    component: React.lazy(() => import('src/routes/PaymentInformation/views/index.tsx')),
  },
  "/claim/payment-limit/list": {
    component: React.lazy(() => import('src/routes/PaymentLimit/views/index.tsx')),
  },
  "/claim/pending/apply": {
    component: React.lazy(() => import('src/routes/PendingMessages/views/apply')),
    models: [
      PendingMessagesModelsIndexJs
    ],
  },
  "/claim/pending/claim": {
    component: React.lazy(() => import('src/routes/PendingMessages/views/claim')),
    models: [
      PendingMessagesModelsIndexJs,
      PendingMessagesModelsApplyJs
    ],
  },
  "/claim/pending-audit/apply": {
    component: React.lazy(() => import('src/routes/PendingMessages/views/apply')),
    models: [
      PendingMessagesModelsIndexJs
    ],
  },
  "/claim/pending-audit/claim": {
    component: React.lazy(() => import('src/routes/PendingMessages/views/claim')),
    models: [
      PendingMessagesModelsIndexJs,
      PendingMessagesModelsApplyJs
    ],
  },
  "/claim/personnel-management/list": {
    component: React.lazy(() => import('src/routes/PersonnelManagement/views/index')),
    models: [
      PersonnelManagementModelsIndexTsx
    ],
  },
  "/claim/privilege/position/list": {
    component: React.lazy(() => import('src/routes/Privilege/views/positionManage/index')),
    models: [
      PrivilegeModelsIndexJs
    ],
  },
  "/claim/privilege/position/add": {
    component: React.lazy(() => import('src/routes/Privilege/views/positionManage/addOrEdit')),
    models: [
      PrivilegeModelsIndexJs
    ],
  },
  "/claim/privilege/position/edit/:id": {
    component: React.lazy(() => import('src/routes/Privilege/views/positionManage/addOrEdit')),
    models: [
      PrivilegeModelsIndexJs
    ],
  },
  "/claim/privilege/position/detail/:id": {
    component: React.lazy(() => import('src/routes/Privilege/views/PositionSearch/detail')),
    models: [
      PrivilegeModelsIndexJs
    ],
  },
  "/claim/privilege-allocation/list": {
    component: React.lazy(() => import('src/routes/PrivilegeAllocation/views/index')),
    models: [
      PrivilegeAllocationModelsIndexJs
    ],
  },
  "/claim/procurement-and-reimbursement/list": {
    component: React.lazy(() => import('src/routes/ProcurementAndReimbursement/views/index')),
    models: [
      ProcurementAndReimbursementModelsIndexTs
    ],
  },
  "/claim/project-manage": {
    component: React.lazy(() => import('src/routes/ProjectManage/views/index')),
    models: [
      ProjectManageModelsIndexTs
    ],
  },
  "/claim/department-project-manage": {
    component: React.lazy(() => import('src/routes/ProjectManage/views/departmentProjectManage')),
    models: [
      ProjectManageModelsIndexTs
    ],
  },
  "/claim/purchase-config/index": {
    component: React.lazy(() => import('src/routes/PurchaseConfig/views/index')),
    models: [
      PurchaseConfigModelsIndexTs
    ],
  },
  "/claim/purchase-declare/index": {
    component: React.lazy(() => import('src/routes/PurchaseDeclare/views/index')),
    models: [
      PurchaseDeclareModelsIndexJs
    ],
  },
  "/claim/purchase-management/index": {
    component: React.lazy(() => import('src/routes/PurchaseManagement/views/index')),
  },
  "/claim/purchase-pool": {
    component: React.lazy(() => import('src/routes/PurchaseNeedPool/views/index')),
  },
  "/claim/my-purchase-requisition": {
    component: React.lazy(() => import('src/routes/PurchaseNeedPool/views/index')),
  },
  "/claim/purchase-order-management": {
    component: React.lazy(() => import('src/routes/PurchaseOrderManagement/views/index')),
  },
  "/claim/purchase-workbench": {
    component: React.lazy(() => import('src/routes/PurchaseWorkbench/views/index')),
    models: [
      PurchaseWorkbenchModelsIndexJs
    ],
  },
  "/claim/rental-settlement/list": {
    component: React.lazy(() => import('src/routes/RentalSettlement/views/index')),
  },
  "/claim/salary/payment-flow": {
    component: React.lazy(() => import('src/routes/Salary/views/paymentFlow/index')),
    models: [
      SalaryModelsIndexTs
    ],
  },
  "/claim/salary/salary-sheet-manage": {
    component: React.lazy(() => import('src/routes/Salary/views/salarySheetManage/index')),
    models: [
      SalaryModelsIndexTs
    ],
  },
  "/claim/salary/payee-manage": {
    component: React.lazy(() => import('src/routes/Salary/views/payeeManage/index')),
    models: [
      SalaryModelsPayeeManageTs
    ],
  },
  "/claim/salary/template-manage": {
    component: React.lazy(() => import('src/routes/Salary/views/templateManage/index')),
    models: [
      SalaryModelsTemplateManageTs
    ],
  },
  "/claim/salary/project-manage": {
    component: React.lazy(() => import('src/routes/Salary/views/projectManage/index')),
    models: [
      SalaryModelsSalaryProjectManageTs
    ],
  },
  "/claim/salary/apply-list": {
    component: React.lazy(() => import('src/routes/Salary/views/applyList/index')),
    models: [
      SalaryModelsIndexTs
    ],
  },
  "/claim/salary/apply-all": {
    component: React.lazy(() => import('src/routes/Salary/views/applyList/myAll')),
    models: [
      SalaryModelsIndexTs
    ],
  },
  "/claim/salary/audit-list": {
    component: React.lazy(() => import('src/routes/Salary/views/auditList/index')),
    models: [
      SalaryModelsIndexTs
    ],
  },
  "/claim/salary/details-list": {
    component: React.lazy(() => import('src/routes/Salary/views/wageDetailsList/index')),
    models: [
      SalaryModelsIndexTs
    ],
  },
  "/claim/scenese-manage": {
    component: React.lazy(() => import('src/routes/SceneseManage/views/index')),
  },
  "/claim/operation/sensitive-word": {
    component: React.lazy(() => import('src/routes/SensitiveWord/views/index')),
    models: [
      SensitiveWordModelsIndexTs
    ],
  },
  "/claim/settlement": {
    component: React.lazy(() => import('src/routes/Settlement/views/index')),
  },
  "/claim/collection/details": {
    component: React.lazy(() => import('src/routes/SmallCollection/views/details')),
    models: [
      SmallCollectionModelsCollectionDetailsTs
    ],
  },
  "/claim/collection/transfordetails": {
    component: React.lazy(() => import('src/routes/SmallCollection/views/transfordetails')),
  },
  "/claim/small-entrust/collection-deduction-voucher": {
    component: React.lazy(() => import('src/routes/SmallEntrust/views/collectionDeductionVoucher')),
    models: [
      SmallEntrustModelsIndexTs
    ],
  },
  "/claim/small-entrust/carry-over-payment": {
    component: React.lazy(() => import('src/routes/SmallEntrust/views/carryOverPayment')),
    models: [
      SmallEntrustModelsIndexTs
    ],
  },
  "/claim/small-entrust/child-account-transfer": {
    component: React.lazy(() => import('src/routes/SmallEntrust/views/childAccountTransfer')),
    models: [
      SmallEntrustModelsIndexTs
    ],
  },
  "/claim/small-entrust/statisticsOverview": {
    component: React.lazy(() => import('src/routes/SmallEntrust/views/statisticsOverview')),
    models: [
      SmallEntrustModelsIndexTs
    ],
  },
  "/claim/small-entrust/collection-deduction-voucher-transfor": {
    component: React.lazy(() => import('src/routes/SmallEntrust/views/collectionDeductionVoucherTransfor')),
    models: [
      SmallEntrustModelsIndexTs
    ],
  },
  "/claim/small-entrust/repayment/:type?": {
    component: React.lazy(() => import('src/routes/SmallEntrust/views/repayment')),
    models: [
      SmallEntrustModelsIndexTs
    ],
  },
  "/claim/small-entrust/summaryList": {
    component: React.lazy(() => import('src/routes/SmallEntrust/views/summaryList')),
    models: [
      SmallEntrustModelsIndexTs
    ],
  },
  "/claim/supplier-info/index": {
    component: React.lazy(() => import('src/routes/Supplier/views/index')),
    models: [
      SupplierModelsIndexTs
    ],
  },
  "/claim/old-supplier-info/index": {
    component: React.lazy(() => import('src/routes/SupplierInfo/views/index')),
    models: [
      SupplierInfoModelsIndexTs
    ],
  },
  "/claim/tags-management": {
    component: React.lazy(() => import('src/routes/TagsManagement/views/index')),
  },
  "/claim/tenant-manage": {
    component: React.lazy(() => import('src/routes/TenantManage/views/list/index')),
    models: [
      TenantManageModelsListTs
    ],
  },
  "/claim/tenant-detail": {
    component: React.lazy(() => import('src/routes/TenantManage/views/detail/index')),
    models: [
      TenantManageModelsDetailTs
    ],
  },
  "/claim/tender-confirmation-examine/index": {
    component: React.lazy(() => import('src/routes/TenderConfirmationExamine/views/apply')),
    models: [
      TenderConfirmationExamineModelsIndexJs
    ],
  },
  "/claim/tender-confirmation-request/index": {
    component: React.lazy(() => import('src/routes/TenderConfirmationRequest/views/index')),
  },
  "/claim/third-license": {
    component: React.lazy(() => import('src/routes/ThirdLicense/views/index')),
    models: [
      ThirdLicenseModelsIndexTs
    ],
  },
  "/claim/totalBudget/fundBudget": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/fundBudgetList/index')),
    models: [
      TotalBudgetModelsFundBudgetTs
    ],
  },
  "/claim/totalBudget/projectLibrary": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/projectLibrary/index')),
    models: [
      TotalBudgetModelsProjectLibraryTs,
      TotalBudgetModelsUnitManageTs
    ],
  },
  "/claim/totalBudget/budgetProject": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/budgetProject/index')),
    models: [
      TotalBudgetModelsBudgetProjectTs
    ],
  },
  "/claim/otherFunds/project": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/budgetProject/index')),
    models: [
      TotalBudgetModelsBudgetProjectTs
    ],
  },
  "/claim/totalBudget/budgetSubject": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/budgetSubject/index')),
    models: [
      TotalBudgetModelsBudgetSubjectTs
    ],
  },
  "/claim/totalBudget/budgetTemplate": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/budgetTemplate/index')),
    models: [
      TotalBudgetModelsBudgetTemplateTs
    ],
  },
  "/claim/totalBudget/budgetPlanning/:identity?": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/budgetPlanning/index')),
    models: [
      TotalBudgetModelsBudgetPlanningTs
    ],
  },
  "/claim/totalBudget/perform/table/:category": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/performTable/index')),
    models: [
      TotalBudgetModelsPerformTableTs
    ],
  },
  "/claim/totalBudget/budgetAdjust": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/budgetAdjust/index')),
    models: [
      TotalBudgetModelsBudgetAdjustTs
    ],
  },
  "/claim/totalBudget/detailedManagement": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/detailedManagement/index')),
  },
  "/claim/totalBudget/detailedSummaryManagement": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/detailedManagement/summaryList')),
  },
  "/claim/totalBudget/purchaseSituation": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/purchaseSituation/index')),
    models: [
      TotalBudgetModelsPurchaseSituationTs
    ],
  },
  "/claim/totalBudget/detailedQuery": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/detailedQuery/index')),
    models: [
      TotalBudgetModelsUnitManageTs
    ],
  },
  "/claim/totalBudget/detailedBudget": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/detailedBudget/index')),
    models: [
      TotalBudgetModelsDetailedBudgetTs,
      TotalBudgetModelsUnitManageTs
    ],
  },
  "/claim/totalBudget/addReduction": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/budgetAddReduction/index')),
    models: [
      TotalBudgetModelsBudgetAddReductionTs
    ],
  },
  "/claim/totalBudget/deptDetailedQuery": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/detailedQuery/detailedDepQueryList')),
    models: [
      TotalBudgetModelsUnitManageTs
    ],
  },
  "/claim/totalBudget/deptDetailedChange": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/detailedQuery/detailedDepQueryListChange')),
    models: [
      TotalBudgetModelsUnitManageTs
    ],
  },
  "/claim/totalBudget/formBudgetQuery": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/formBudgetQuery/index')),
    models: [
      TotalBudgetModelsFormBudgetQueryTs
    ],
  },
  "/claim/totalBudget/revisedFormQuery": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/revisedFormQuery/index')),
    models: [
      TotalBudgetModelsRevisedFormQueryTs
    ],
  },
  "/claim/totalBudget/costItem": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/costItem/index')),
    models: [
      TotalBudgetModelsCostItemTs
    ],
  },
  "/claim/totalBudget/projectManage/agent": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/projectManageAgent')),
    models: [
      TotalBudgetModelsProjectManageTs
    ],
  },
  "/claim/totalBudget/projectManage/finance": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/projectManageFinance')),
    models: [
      TotalBudgetModelsProjectManageTs
    ],
  },
  "/claim/totalBudget/govBudgetProject": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/govBudgetProject')),
    models: [
      TotalBudgetModelsGovBudgetProjectTs
    ],
  },
  "/claim/totalBudget/perform/indicator": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/performIndicator')),
    models: [
      TotalBudgetModelsPerformIndicatorTs
    ],
  },
  "/claim/totalBudget/projectSubjectSummary": {
    component: React.lazy(() => import('src/routes/TotalBudget/views/projectSubjectSummary')),
    models: [
      TotalBudgetModelsProjectSubjectSummaryTs
    ],
  },
  "/claim/transfer/:type": {
    component: React.lazy(() => import('src/routes/TransferPage/views/index')),
  },
  "/claim/trial-record": {
    component: React.lazy(() => import('src/routes/TrialRecord/views/index')),
  },
  "/claim/trip-order": {
    component: React.lazy(() => import('src/routes/TripOrder/views/index')),
    models: [
      TripOrderModelsIndexJs
    ],
  },
  "/claim/unit/manage": {
    component: React.lazy(() => import('src/routes/Unit/views/index')),
    models: [
      UnitModelsIndexJs
    ],
  },
  "/claim/unit/notice/health": {
    component: React.lazy(() => import('src/routes/Unit/views/notice/health')),
    models: [
      UnitModelsIndexJs
    ],
  },
  "/claim/unit/notice/finance": {
    component: React.lazy(() => import('src/routes/Unit/views/notice/finance')),
    models: [
      UnitModelsIndexJs
    ],
  },
  "/claim/unit/notice/hospital": {
    component: React.lazy(() => import('src/routes/Unit/views/notice/hospital')),
    models: [
      UnitModelsIndexJs
    ],
  },
  "/claim/personal-card/index": {
    component: React.lazy(() => import('src/routes/UnitPersonalCardManage/views/index')),
    models: [
      UnitPersonalCardManageModelsIndexTs
    ],
  },
  "/claim/virtual-organization": {
    component: React.lazy(() => import('src/routes/VirtualOrganization/views/index')),
    models: [
      VirtualOrganizationModelsIndexJs
    ],
  },
  "/claim/warning/messages": {
    component: React.lazy(() => import('src/routes/WarningMessages/views/index')),
    models: [
      WarningMessagesModelsIndexJs
    ],
  },
  "/claim/work-plan/list": {
    component: React.lazy(() => import('src/routes/WorkPlan/views/index')),
    models: [
      WorkPlanModelsIndexTsx
    ],
  },
  "/claim/work-summary/list": {
    component: React.lazy(() => import('src/routes/WorkSummary/views/index')),
    models: [
      WorkSummaryModelsIndexTsx
    ],
  },
  "/claim/zoning-backstage/district-manage": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/districtManage/index')),
    models: [
      ZoningBackstageModelsDistrictManageTsx
    ],
  },
  "/claim/zoning-backstage/unit-manage": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/unitManage/index')),
    models: [
      ZoningBackstageModelsUnitManageTsx
    ],
  },
  "/claim/zoning-backstage/detail/unit-manage/:id?/:code?/:name?": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/unitManage/detail')),
    models: [
      ZoningBackstageModelsUnitManageTsx
    ],
  },
  "/claim/zoning-backstage/zone-identity-manage/:fromPage?": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/zoneIdentityManage/index')),
    models: [
      ZoningBackstageModelsZoneIdentityManageTsx
    ],
  },
  "/claim/luban/panelPage": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/panelPage/index')),
  },
  "/claim/zoning-backstage/event-manage/list": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/eventManage/index')),
    models: [
      ZoningBackstageModelsEventManageTs
    ],
  },
  "/claim/company/event-manage/list": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/eventManage/index')),
    models: [
      ZoningBackstageModelsEventManageTs
    ],
  },
  "/claim/zoning-backstage/application-manage/list": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/applicationManage/index')),
  },
  "/claim/zoning-backstage/application-manage/detail/:applyType?": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/applicationManage/detail')),
  },
  "/claim/zoning-backstage/patrol-inspection/index/:fromPage?/:districtCode?": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/patrolInspection/index')),
  },
  "/claim/zoning-backstage/patrol-inspection/list/:fromPage?": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/patrolInspection/list')),
  },
  "/claim/zoning-backstage/patrol-inspection/detail/:district_code?/:pt?/:inspectionCount?": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/patrolInspection/detail')),
  },
  "/claim/zoning-backstage/dataManage/overview": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/overview')),
  },
  "/claim/zoning-backstage/dataManage/overviewHZ": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/overviewHZ')),
  },
  "/claim/zoning-backstage/dataManage/dashboardYH": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/dashboardYH')),
  },
  "/claim/zoning-backstage/dataManage/usageHZ": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/usageHZ')),
  },
  "/claim/zoning-backstage/dataManage/districtRankingHZ": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/districtRankingHZ')),
  },
  "/claim/zoning-backstage/dataManage/usage": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/usage')),
  },
  "/claim/zoning-backstage/dataManage/districtRanking": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/districtRanking')),
  },
  "/claim/zoning-backstage/dataManage/dashboard": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/commonDashboard')),
  },
  "/claim/zoning-backstage/dataManage/weakControlDetails": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/weakControlDetails')),
  },
  "/claim/zoning-backstage/dataManage/businessIncrease": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/businessIncrease')),
  },
  "/claim/zoning-backstage/dataManage/riskDetails": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/riskDetails')),
  },
  "/claim/zoning-backstage/dataManage/dashTable": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/commonTable')),
  },
  "/claim/zoning-backstage/dataManage/carRefuel": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/dataManage/carRefuel')),
  },
  "/claim/zoning-backstage/content-article": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/contentManage/articleManage/index.tenant')),
    models: [
      ZoningBackstageModelsContentManageTs
    ],
  },
  "/claim/operation/content-article": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/contentManage/articleManage/index.operation')),
    models: [
      ZoningBackstageModelsContentManageTs
    ],
  },
  "/claim/content/list": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/contentManage/articleManage/index.company')),
    models: [
      ZoningBackstageModelsContentManageTs
    ],
  },
  "/claim/zoning-backstage/content-banner": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/contentManage/bannerManage/index.tenant')),
    models: [
      ZoningBackstageModelsContentManageTs
    ],
  },
  "/claim/banner/manage": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/contentManage/bannerManage/index.operation')),
    models: [
      ZoningBackstageModelsContentManageTs
    ],
  },
  "/claim/zoning-backstage/content-popup": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/contentManage/popupManage/index.tenant')),
    models: [
      ZoningBackstageModelsContentManageTs
    ],
  },
  "/claim/notice-config": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/contentManage/popupManage/index.operation')),
    models: [
      ZoningBackstageModelsContentManageTs
    ],
  },
  "/claim/unlock/manage": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/unlockManage/index.operation')),
  },
  "/claim/zoning-backstage/unlock/manage": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/unlockManage/index.tenant')),
  },
  "/claim/zoning-backstage/system-monitoring": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/systemMonitoring/index')),
  },
  "/claim/zoning-backstage/workbench": {
    component: React.lazy(() => import('src/routes/ZoningBackstage/views/workbench/index')),
  },

};